import 'ui-core/plugins/slide/js/slide';

UX.slide.customViewPorts = function () {
    if ($('.journal-home').length) {
        UX.slide.elementvPort = 'screen-sm';
    }
};
